<breadcrumb [paginas]="[
  {route:'/home', name:'Home'},
  {route:'/extracao-dados', name:'Extração de Dados'}
]" aria-label="Navegação de breadcrumb"></breadcrumb>

<section class="section-saudacao">
  <div class="container">
    <h3 class="titulo-page">Extração de Dados – Conviva</h3>
  </div>
</section>

<!-- ENTIDADE -->
<section class="section-filtro">
  <div class="container">
    <div class="grupo-filter w-100">
      <p><b>Entidade</b></p>
      <ng-select
        [items]="entidades"
        bindLabel="label"
        bindValue="id"
        placeholder="Selecione uma entidade"
        [(ngModel)]="entidadeSelecionadaId"
        (change)="onEntidadeChange()"
        [loading]="carregandoEntidades"
        [clearable]="false">
      </ng-select>

      <div class="estado-entidades-vazio" *ngIf="exibirInicializacaoEntidades">
        <p>Nenhuma entidade de extração encontrada.</p>
        <button
          type="button"
          class="btn-primario"
          (click)="inicializarEntidades()"
          [disabled]="inicializandoEntidades">
          Inicializar entidades
        </button>
      </div>
    </div>
  </div>
</section>

<!-- FILTROS -->
<section class="section-filtro" *ngIf="metadata">
  <div class="container container-bloco">
    <h4 class="bloco-titulo">Filtros</h4>

    <div class="grid-filtros" *ngIf="metadata.filtros.length; else semFiltros">
      <div class="grupo-filter" *ngFor="let filtro of metadata.filtros">
        <p>
          <b>{{ filtro.label }}</b>
          <span *ngIf="filtro.obrigatorio" class="obrigatorio"> *</span>
        </p>

        <ng-container [ngSwitch]="tipoFiltro(filtro)">

          <ng-select
            *ngSwitchCase="'ure'"
            [items]="diretorias"
            bindLabel="nomeDiretoria"
            bindValue="codigoDiretoria"
            placeholder="Selecione a Diretoria"
            [loading]="carregandoDiretorias"
            [(ngModel)]="filtrosValores[filtro.id]"
            [name]="'filtro_' + filtro.id"
            (change)="onUreChange(filtro)">
          </ng-select>

          <ng-select
            *ngSwitchCase="'escola'"
            [items]="escolas"
            bindLabel="nomeEscola"
            bindValue="codigoEscola"
            placeholder="Selecione a Escola"
            [loading]="carregandoEscolas"
            [disabled]="!escolas.length && !carregandoEscolas"
            [(ngModel)]="filtrosValores[filtro.id]"
            [name]="'filtro_' + filtro.id">
          </ng-select>

          <ng-select
            *ngSwitchCase="'status'"
            [items]="opcoesStatus(filtro)"
            bindLabel="label"
            bindValue="value"
            placeholder="Selecione o Status"
            [(ngModel)]="filtrosValores[filtro.id]"
            [name]="'filtro_' + filtro.id">
          </ng-select>

          <ng-select
            *ngSwitchCase="'tipo'"
            [items]="categoriasTipo"
            bindLabel="descricaoSubCategoria"
            bindValue="codigoSubCategoria"
            placeholder="Selecione o Tipo"
            [loading]="carregandoCategoriasTipo"
            [(ngModel)]="filtrosValores[filtro.id]"
            [name]="'filtro_' + filtro.id">
          </ng-select>

          <ng-select
            *ngSwitchCase="'psicologo'"
            [items]="psicologos"
            bindLabel="nomePsicologoCompleto"
            bindValue="codigoPsicologo"
            placeholder="Selecione o Psicólogo"
            [loading]="carregandoPsicologos"
            [disabled]="!psicologos.length && !carregandoPsicologos"
            [(ngModel)]="filtrosValores[filtro.id]"
            [name]="'filtro_' + filtro.id">
          </ng-select>

          <input
            *ngSwitchCase="'data'"
            type="date"
            class="form-control"
            [(ngModel)]="filtrosValores[filtro.id]"
            [name]="'filtro_' + filtro.id" />

          <input
            *ngSwitchDefault
            type="text"
            class="form-control"
            [placeholder]="'Filtrar por ' + filtro.label"
            [attr.inputmode]="ehFiltroRaEstudante(filtro) ? 'numeric' : null"
            [attr.maxlength]="ehFiltroRaEstudante(filtro) ? 12 : null"
            [attr.pattern]="ehFiltroRaEstudante(filtro) ? '[0-9]*' : null"
            [ngModel]="filtrosValores[filtro.id]"
            (ngModelChange)="onFiltroTextoChange(filtro, $event)"
            [name]="'filtro_' + filtro.id" />

        </ng-container>
      </div>
    </div>

    <ng-template #semFiltros>
      <p class="info-vazio">Esta entidade não possui filtros disponíveis.</p>
    </ng-template>

    <div class="bloco-acoes">
      <button type="button" class="btn-secundario" (click)="limparFiltros()">Limpar Filtros</button>
      <button type="button" class="btn-primario" (click)="buscar()" [disabled]="carregandoPreview">Buscar</button>
    </div>
  </div>
</section>

<!-- COLUNAS -->
<section class="section-filtro" *ngIf="metadata">
  <div class="container container-bloco">
    <h4 class="bloco-titulo">Colunas</h4>

    <div class="grid-colunas" *ngIf="metadata.colunas.length; else semColunas">
      <label class="check-coluna" *ngFor="let coluna of metadata.colunas">
        <input
          type="checkbox"
          [checked]="colunaMarcada(coluna.id)"
          (change)="alternarColuna(coluna.id, $any($event.target).checked)" />
        <span>{{ coluna.label }}</span>
      </label>
    </div>

    <ng-template #semColunas>
      <p class="info-vazio">Esta entidade não possui colunas disponíveis.</p>
    </ng-template>

    <div class="bloco-acoes">
      <button type="button" class="btn-secundario" (click)="selecionarTodasColunas()">Selecionar Todas</button>
      <button type="button" class="btn-secundario" (click)="limparSelecaoColunas()">Limpar Seleção</button>
    </div>
  </div>
</section>

<!-- PREVIEW -->
<section class="section-filtro" *ngIf="metadata">
  <div class="container container-bloco">
    <div class="bloco-header">
      <h4 class="bloco-titulo">Resultado (Preview)</h4>

      <div class="bloco-paginacao-info" *ngIf="buscaRealizada">
        <label class="seletor-tamanho">
          <span>Itens por página:</span>
          <select
            class="form-control"
            [(ngModel)]="tamanhoPagina"
            (change)="onTamanhoPaginaChange()">
            <option *ngFor="let opc of opcoesTamanhoPagina" [ngValue]="opc">{{ opc }}</option>
          </select>
        </label>
      </div>
    </div>

    <div class="tabela-preview" *ngIf="previewRegistros.length; else semPreview">
      <div class="tabela-scroll">
        <table>
          <thead>
            <tr>
              <th *ngFor="let c of previewColunas" [title]="c.label">{{ c.label }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let registro of previewRegistros">
              <td *ngFor="let c of previewColunas" [title]="registro[c.campo] ?? ''">{{ registro[c.campo] }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="bloco-paginacao" *ngIf="previewTotal > tamanhoPagina">
        <ngb-pagination
          [collectionSize]="previewTotal"
          [pageSize]="tamanhoPagina"
          [page]="paginaAtual"
          (pageChange)="onPaginaChange($event)"
          [maxSize]="5"
          [boundaryLinks]="true"
          [ellipses]="true"
          class="d-flex justify-content-center">
        </ngb-pagination>
      </div>

      <p class="info-total" *ngIf="previewTotal > 0">
        Total: {{ previewTotal }} registro(s).
        Exibindo página {{ paginaAtual }} de {{ totalPaginas }}.
      </p>
    </div>

    <ng-template #semPreview>
      <p class="info-vazio" *ngIf="!buscaRealizada">
        Nenhum registro carregado. Selecione filtros/colunas e clique em Buscar.
      </p>
      <p class="info-vazio" *ngIf="buscaRealizada">
        Nenhum registro encontrado para os filtros informados.
      </p>
    </ng-template>
  </div>
</section>

<!-- EXPORTAÇÃO -->
<section class="section-filtro" *ngIf="metadata">
  <div class="container container-bloco">
    <h4 class="bloco-titulo">Exportação</h4>
    <div class="bloco-acoes">
      <button type="button" class="btn-secundario" (click)="exportarCsv()" [disabled]="exportando">Exportar CSV</button>
      <button type="button" class="btn-secundario" (click)="exportarExcel()" [disabled]="exportando">Exportar Excel</button>
    </div>
  </div>
</section>

<ngx-spinner type="ball-clip-rotate" size="medium" color="#fff" [fullScreen]="true">
  <p style="color: white">Carregando...</p>
</ngx-spinner>
